/* 三國逗陣打 · 赤壁 5v5 地圖（DOTA 式對角佈局）
 * 世界座標：x 向右、y 向下（畫面上的前後縱深；地面度量要除以 K = 0.7，所以 6000 × 4460 在地面上接近正方形）。
 * 聯軍（team 0）本營在左下、魏軍（team 1）在右上。上路沿左緣再沿上緣、下路沿下緣再沿右緣、中路走對角線。
 * 長江由左上流向右下，全段是可以涉水的淺灘。兩軍的一切以地圖中心做點對稱。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from './sg.ts';

// 地圖由 buildMap(into) 一次算完、寫進 into（列傳模式要能換地圖）。目前只有赤壁；之後的地圖以參數傳入。
function buildMap(into = {}) {
  const W = 6000, H = 4460, CX = 3000, CY = 2360, YMIN = 300, YMAX = H - 40;
  const M = Object.assign(into, { W, H, name: '赤壁', center: [CX, CY] });
  const mir = (p) => [W - p[0], 2 * CY - p[1]];
  M.mir = mir;

  function rng(seed) {
    return function () {
      seed = (seed + 0x6d2b79f5) | 0;
      let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  M.rng = rng;

  // ---------- 長江：通過地圖中心、在地面上與中路垂直的直線 ----------
  const RS = 0.779, RHW = 120, RN = Math.hypot(RS, 1); // 斜率、半寬
  M.riverDist = (x, y) => ((y - CY) - RS * (x - CX)) / RN; // > 0 是聯軍那一側（左下）
  M.river = { a: [CX - 3200, CY - 3200 * RS], b: [CX + 3200, CY + 3200 * RS], hw: RHW };
  M.fords = [];

  // ---------- 路線（由聯軍本營走向魏軍本營） ----------
  const TOP = [[470, 3800], [470, 980], [750, 680], [5250, 680]];
  M.lanes = { top: TOP, mid: [[760, 3860], mir([760, 3860])], bot: TOP.map(mir).reverse() };
  M.laneFor = (lane, team) => (team === 0 ? M.lanes[lane] : M.lanes[lane].slice().reverse());
  M.laneLen = {};
  for (const k in M.lanes) { let s = 0; const L = M.lanes[k]; for (let i = 0; i < L.length - 1; i++) s += Math.hypot(L[i + 1][0] - L[i][0], L[i + 1][1] - L[i][1]); M.laneLen[k] = s; }
  // 某一點在路線上的進度（從聯軍那一端算起的距離）
  M.laneS = function (lane, x, y) {
    const L = M.lanes[lane];
    let best = 0, bd = 1e12, acc = 0;
    for (let i = 0; i < L.length - 1; i++) {
      const a = L[i], b = L[i + 1], vx = b[0] - a[0], vy = b[1] - a[1], len = Math.hypot(vx, vy);
      const t = Math.max(0, Math.min(1, ((x - a[0]) * vx + (y - a[1]) * vy) / (len * len)));
      const d = Math.hypot(x - a[0] - vx * t, y - a[1] - vy * t);
      if (d < bd) { bd = d; best = acc + t * len; }
      acc += len;
    }
    return best;
  };
  M.laneAt = function (lane, s) {
    const L = M.lanes[lane];
    s = Math.max(0, Math.min(M.laneLen[lane], s));
    for (let i = 0; i < L.length - 1; i++) {
      const a = L[i], b = L[i + 1], len = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (s <= len || i === L.length - 2) { const t = Math.min(1, s / len); return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
      s -= len;
    }
    return L[L.length - 1].slice();
  };

  M.bases = [{ x: 460, y: 4080 }, { x: W - 460, y: 2 * CY - 4080 }];
  M.shopR = 440;
  M.boss = { x: 1900, y: 1503 };            // 呂布守在上游的沙洲
  M.island = { x: 1900, y: 1503, r: 175 };

  // 照 3.7D：邊路各三座城寨加一座兵營，中路四座城寨、沒有兵營（1 最外，數字越大越靠近本營）。
  // 魏軍那一側是點對稱，所以上下路對調
  const SWAP = { top: 'bot', mid: 'mid', bot: 'top' };
  const T0 = [['top', 470, 1450, 1], ['top', 470, 2500, 2], ['top', 470, 3450, 3], ['mid', 2552, 2660, 1], ['mid', 2104, 2960, 2], ['mid', 1656, 3260, 3], ['mid', 1208, 3560, 4],
    ['bot', 4100, 4040, 1], ['bot', 2600, 4040, 2], ['bot', 1150, 4040, 3]];
  M.towers = [];
  T0.forEach(([lane, x, y, tier]) => { const inner = tier === (lane === 'mid' ? 4 : 3); M.towers.push({ team: 0, lane, x, y, tier, inner }); const q = mir([x, y]); M.towers.push({ team: 1, lane: SWAP[lane], x: q[0], y: q[1], tier, inner }); });
  M.barracks = [];
  [['top', 350, 3670], ['bot', 900, 4160]].forEach(([lane, x, y]) => { M.barracks.push({ team: 0, lane, x, y }); const q = mir([x, y]); M.barracks.push({ team: 1, lane: SWAP[lane], x: q[0], y: q[1] }); });

  // 糧倉：聯軍在上路（左路）、魏軍在下路（右路），位在第一座城寨之後；定時發錢給全隊
  M.granaries = [{ team: 0, lane: 'top', x: 640, y: 2300 }];
  { const q = mir([640, 2300]); M.granaries.push({ team: 1, lane: 'bot', x: q[0], y: q[1] }); }
  // 路邊的神秘商店：江兩岸各一間，站在旁邊就能買裝備。[x, y, 種類]
  // 長江商船（v0.5.5）：泊在上下路浮橋外、江口最裡面的死角，讓邊路不用回城也能補裝，也讓角落容易開打；位置與兩邊一塔約略等距
  M.shops = [[3126, 3055, 'mystic'], [...mir([3126, 3055]), 'mystic'], [460, 410, 'ship'], [...mir([460, 410]), 'ship']];
  // 購買範圍：商船比神秘商店小，要貼著船邊才能買
  M.SHOP_R = { mystic: 190, ship: 120 };
  M.shopAt = (x, y) => M.shops.some((s) => Math.hypot(x - s[0], y - s[1]) < M.SHOP_R[s[2]]);
  // 離某一點最近的路線
  M.laneNear = function (x, y) {
    let best = 'mid', bd = 1e12;
    for (const k in M.lanes) { const p = M.laneAt(k, M.laneS(k, x, y)), d = Math.hypot(p[0] - x, p[1] - y); if (d < bd) { bd = d; best = k; } }
    return best;
  };

  M.camps = [];
  [['huangjin', 1250, 2150], ['bandit', 1500, 3050], ['huangjin', 2700, 3520], ['bandit', 3700, 3450]].forEach(([kind, x, y], i) => {
    M.camps.push({ id: 'c0' + i, kind, x, y, side: 0 });
    const q = mir([x, y]); M.camps.push({ id: 'c1' + i, kind, x: q[0], y: q[1], side: 1 });
  });
  // 林間小空地（原本放酒罈、石頭的位置；投擲已移除，保留空地讓林子的形狀不變）
  M.glades = [];
  [[700, 2000], [700, 3000], [2000, 3250], [2700, 2800], [2000, 4200], [3400, 4200]].forEach(([x, y]) => {
    M.glades.push({ x, y }); const q = mir([x, y]); M.glades.push({ x: q[0], y: q[1] });
  });

  // 淺灘（v0.5.3）：路上與野區的幾窪淺水，可以走、算「濕」，甘寧「錦帆」的浪在這裡也會擊飛。[x, y, rx, ry]
  const S0 = [[470, 1975, 150, 105], [3350, 4040, 150, 105], [1400, 2550, 130, 90], [3200, 3480, 130, 90]]; // 上路、下路一二塔之間；野區營地之間的林道
  M.shallows = [];
  S0.forEach((b) => { M.shallows.push(b); const q = mir(b); M.shallows.push([q[0], q[1], b[2], b[3]]); });
  M.shallowAt = (x, y) => M.shallows.some((b) => ((x - b[0]) / b[2]) ** 2 + ((y - b[1]) / b[3]) ** 2 <= 1);
  // 在水裡：江面（不含浮橋）或淺灘
  M.waterAt = (x, y) => (Math.abs(M.riverDist(x, y)) < RHW && !M.onBridge(x, y)) || M.shallowAt(x, y);
  // 蘆葦叢：[x, y, rx, ry]
  const B0 = [[900, 1900, 150, 52], [2150, 2480, 150, 52], [3300, 3300, 160, 52], [4600, 3720, 150, 52], [1700, 3700, 150, 50]];
  M.brush = [];
  B0.forEach((b) => { M.brush.push(b); const q = mir(b); M.brush.push([q[0], q[1], b[2], b[3]]); });
  M.brushAt = function (x, y) {
    for (let i = 0; i < M.brush.length; i++) {
      const b = M.brush[i], dx = (x - b[0]) / b[2], dy = (y - b[1]) / b[3];
      if (dx * dx + dy * dy <= 1) return i;
    }
    return -1;
  };

  // ---------- 導航圖（聯軍側；魏軍側是加上 ' 的鏡像節點） ----------
  const N0 = {
    B: [620, 3960],
    T3: [470, 3450], T2: [470, 2500], T1: [470, 1450], TC: [560, 900],
    M3: [1208, 3560], M2: [1880, 3110], M1: [2552, 2660], MC: [2850, 2460],
    D3: [1150, 4040], D2: [2600, 4040], D1: [4100, 4040], DC: [4900, 4040],
    J1: [1250, 2150], J2: [1500, 3050], J3: [2700, 3520], J4: [3700, 3450],
    R1: [1800, 1620], R2: [4000, 3260],
  };
  const E0 = [['B', 'T3'], ['B', 'M3'], ['B', 'D3'], ['T3', 'T2'], ['T2', 'T1'], ['T1', 'TC'], ['M3', 'M2'], ['M2', 'M1'], ['M1', 'MC'], ['D3', 'D2'], ['D2', 'D1'], ['D1', 'DC'],
    ['T2', 'J1'], ['T1', 'J1'], ['J1', 'J2'], ['J2', 'T3'], ['J2', 'M2'], ['J1', 'M1'], ['J1', 'R1'], ['R1', 'T1'], ['R1', 'M1'],
    ['M2', 'J3'], ['J3', 'D2'], ['J3', 'M3'], ['J3', 'J4'], ['J4', 'D1'], ['J4', 'M1'], ['J4', 'R2'], ['R2', 'MC'], ['R2', 'DC']];
  // 過江：上路轉角、中路、下路轉角，以及上下游各一處野區出口
  const XE = [['TC', "DC'"], ['DC', "TC'"], ['MC', "MC'"], ['R1', "R2'"], ['R2', "R1'"]];
  M.nodes = { LB: [M.boss.x, M.boss.y] };
  for (const k in N0) { M.nodes[k] = N0[k]; M.nodes[k + "'"] = mir(N0[k]); }
  M.edges = [];
  E0.forEach(([a, b]) => { M.edges.push([a, b]); M.edges.push([a + "'", b + "'"]); });
  XE.forEach((e) => M.edges.push(e));
  M.edges.push(['R1', 'LB'], ["R2'", 'LB']);
  M.adj = {};
  for (const k in M.nodes) M.adj[k] = [];
  M.edges.forEach(([a, b]) => { M.adj[a].push(b); M.adj[b].push(a); });

  function segDist(px, py, a, b) {
    const vx = b[0] - a[0], vy = b[1] - a[1], L = vx * vx + vy * vy;
    let t = L ? ((px - a[0]) * vx + (py - a[1]) * vy) / L : 0;
    t = Math.max(0, Math.min(1, t));
    return Math.hypot(px - a[0] - vx * t, py - a[1] - vy * t);
  }
  M.segDist = segDist;

  // ---------- 樹林：成片的林塊（自動避開路、導航線、江面、營地與建築；兩側點對稱） ----------
  // 林塊存在 20px 的格子上。碰撞、視線都查「有號距離場」：林外為正、林內為負，單位是地面度量（y 乘 TY）
  const TY = 1.4;
  M.BODY = 18; // 走路者的身體半徑：林緣與林縫都以它來算
  const SC = 20, SW = Math.ceil(W / SC), SH = Math.ceil(H / SC), NC = SW * SH;
  const forest = new Uint8Array(NC), sdf = new Float32Array(NC), toRoad = new Int32Array(NC);
  const inBounds = (x, y) => x >= 60 && x <= W - 60 && y >= YMIN && y <= YMAX;
  const cellX = (k) => ((k % SW) + 0.5) * SC, cellY = (k) => (((k / SW) | 0) + 0.5) * SC;
  const cellAt = (x, y) => Math.max(0, Math.min(SH - 1, (y / SC) | 0)) * SW + Math.max(0, Math.min(SW - 1, (x / SC) | 0));
  const N4 = [[1, 0], [-1, 0], [0, 1], [0, -1]];
  function sample(x, y) {
    const fx = Math.max(0, Math.min(SW - 1.001, x / SC - 0.5)), fy = Math.max(0, Math.min(SH - 1.001, y / SC - 0.5));
    const i = fx | 0, j = fy | 0, u = fx - i, v = fy - j, k = j * SW + i;
    return (sdf[k] * (1 - u) + sdf[k + 1] * u) * (1 - v) + (sdf[k + SW] * (1 - u) + sdf[k + SW + 1] * u) * v;
  }
  // 倒角距離轉換（地面度量：橫 20、縱 28、斜 34）；src 為 1 的格子距離為 0
  function chamfer(src, out) {
    const WX = SC, WY = SC * TY, WD = Math.hypot(WX, WY);
    for (let k = 0; k < NC; k++) out[k] = src[k] ? 0 : 1e9;
    for (let j = 0; j < SH; j++) for (let i = 0; i < SW; i++) {
      const k = j * SW + i; let d = out[k];
      if (i > 0) d = Math.min(d, out[k - 1] + WX);
      if (j > 0) { d = Math.min(d, out[k - SW] + WY); if (i > 0) d = Math.min(d, out[k - SW - 1] + WD); if (i < SW - 1) d = Math.min(d, out[k - SW + 1] + WD); }
      out[k] = d;
    }
    for (let j = SH - 1; j >= 0; j--) for (let i = SW - 1; i >= 0; i--) {
      const k = j * SW + i; let d = out[k];
      if (i < SW - 1) d = Math.min(d, out[k + 1] + WX);
      if (j < SH - 1) { d = Math.min(d, out[k + SW] + WY); if (i < SW - 1) d = Math.min(d, out[k + SW + 1] + WD); if (i > 0) d = Math.min(d, out[k + SW - 1] + WD); }
      out[k] = d;
    }
  }
  function buildSdf() {
    const dOut = new Float32Array(NC), dIn = new Float32Array(NC), free = new Uint8Array(NC);
    for (let k = 0; k < NC; k++) free[k] = forest[k] ? 0 : 1;
    chamfer(forest, dOut); chamfer(free, dIn);
    for (let k = 0; k < NC; k++) sdf[k] = forest[k] ? -(dIn[k] - 12) : dOut[k] - 12;
  }
  // 從兩邊本營灌水，身體走得到的格子
  function reach() {
    const seen = new Uint8Array(NC), q = [];
    M.bases.forEach((b) => { const k = cellAt(b.x, b.y); seen[k] = 1; q.push(k); });
    while (q.length) {
      const k = q.pop(), i = k % SW, j = (k / SW) | 0;
      for (const [di, dj] of N4) {
        const a = i + di, b = j + dj, n = b * SW + a;
        if (a >= 0 && b >= 0 && a < SW && b < SH && !seen[n] && sdf[n] > M.BODY) { seen[n] = 1; q.push(n); }
      }
    }
    return seen;
  }
  (function grow() {
    const segs = [];
    Object.values(M.lanes).forEach((L) => { for (let i = 0; i < L.length - 1; i++) segs.push([L[i], L[i + 1], 170]); });
    M.edges.forEach(([a, b]) => segs.push([M.nodes[a], M.nodes[b], 120]));
    const rings = [[M.camps, 210], [M.bases, 560], [M.towers, 180], [M.barracks, 170], [M.granaries, 190], [M.shops.map((t) => ({ x: t[0], y: t[1] })), 230], [M.glades, 80], [[M.boss], 300]];
    // 留空：到各種地物的距離減去需要的空間，取最小值（負的就是一定要空著）
    const slack = (x, y) => {
      let s = Math.abs(M.riverDist(x, y)) - (RHW + 80);
      for (const g of segs) s = Math.min(s, segDist(x, y, g[0], g[1]) - g[2]);
      for (const [list, r] of rings) for (const o of list) s = Math.min(s, Math.hypot(x - o.x, y - o.y) - r);
      if (M.brushAt(x, y) >= 0) s = Math.min(s, -1);
      return s;
    };
    // 值雜訊讓林緣起伏；取本點與鏡像點的平均，保持點對稱
    const lat = new Map(), r = rng(20261002);
    const hv = (i, j) => { const k = i * 4096 + j; if (!lat.has(k)) lat.set(k, r() * 2 - 1); return lat.get(k); };
    const vn = (x, y) => {
      const fx = x / 260, fy = y / 260, i = Math.floor(fx), j = Math.floor(fy), u = fx - i, v = fy - j, su = u * u * (3 - 2 * u), sv = v * v * (3 - 2 * v);
      return (hv(i, j) * (1 - su) + hv(i + 1, j) * su) * (1 - sv) + (hv(i, j + 1) * (1 - su) + hv(i + 1, j + 1) * su) * sv;
    };
    for (let k = 0; k < NC; k++) {
      const x = cellX(k), y = cellY(k), q = mir([x, y]);
      forest[k] = !inBounds(x, y) || slack(x, y) > 10 + 34 * (vn(x, y) + vn(q[0], q[1])) / 2 ? 1 : 0;
    }
    // 太小的孤立樹叢（< 12 格）拿掉，免得變成一顆顆的障礙點
    const lab = new Int32Array(NC).fill(-1);
    for (let k0 = 0; k0 < NC; k0++) {
      if (!forest[k0] || lab[k0] >= 0) continue;
      const comp = [k0]; lab[k0] = k0;
      for (let h = 0; h < comp.length; h++) {
        const k = comp[h], i = k % SW, j = (k / SW) | 0;
        for (const [di, dj] of N4) { const a = i + di, b = j + dj, n = b * SW + a; if (a >= 0 && b >= 0 && a < SW && b < SH && forest[n] && lab[n] < 0) { lab[n] = k0; comp.push(n); } }
      }
      if (comp.length < 12) comp.forEach((k) => { forest[k] = 0; });
    }
    buildSdf();
    // 身體走不到的空地（被林縫封死的口袋）填成林子，畫面與碰撞一致
    const seen = reach();
    let filled = 0;
    for (let k = 0; k < NC; k++) if (!forest[k] && !seen[k] && sdf[k] > M.BODY) { forest[k] = 1; filled++; }
    if (filled) buildSdf();
    // 回到路網的流場：從每條導航線上的格子反向 BFS，每格記下往路網走的下一格
    const ok = reach();
    toRoad.fill(-1);
    const bq = [];
    M.edges.forEach(([a, b]) => {
      const A = M.nodes[a], B = M.nodes[b], n = Math.ceil(Math.hypot(B[0] - A[0], B[1] - A[1]) / (SC / 2));
      for (let i = 0; i <= n; i++) {
        const k = cellAt(A[0] + ((B[0] - A[0]) * i) / n, A[1] + ((B[1] - A[1]) * i) / n);
        if (ok[k] && toRoad[k] < 0) { toRoad[k] = k; bq.push(k); }
      }
    });
    for (let h = 0; h < bq.length; h++) {
      const k = bq[h], i = k % SW, j = (k / SW) | 0;
      for (const [di, dj] of [[1, 0], [-1, 0], [0, 1], [0, -1], [1, 1], [1, -1], [-1, 1], [-1, -1]]) {
        const a = i + di, b = j + dj, n = b * SW + a;
        if (a < 0 || b < 0 || a >= SW || b >= SH || !ok[n] || toRoad[n] >= 0) continue;
        if (di && dj && (!ok[j * SW + a] || !ok[b * SW + i])) continue; // 斜走不切林角
        toRoad[n] = k; bq.push(n);
      }
    }
  })();
  M.forestAt = (x, y) => sample(x, y) < 0;
  M.forestDist = sample;

  // 樹：沿林緣種一排（畫成實體，能依前後縱深遮擋角色）；林子裡面由 M.paint 畫成連成一片的樹冠
  M.trees = [];
  (function plant() {
    const r = rng(20260930), taken = [];
    // 只種在朝南或朝側面的林緣：樹往上長，種在北緣會蓋住北邊的通道
    const facing = (x, y) => { const gx = sample(x + 8, y) - sample(x - 8, y), gy = sample(x, y + 8) - sample(x, y - 8); return gy / (Math.hypot(gx, gy) || 1); };
    const fits = (x, y) => { const d = sample(x, y); return inBounds(x, y) && d < -8 && d > -36 && facing(x, y) > -0.25 && taken.every((t) => Math.hypot(x - t[0], (y - t[1]) * TY) > 70); };
    const order = [];
    // 林子深處偶爾冒出高樹，讓樹冠有高低
    const deep = (x, y) => inBounds(x, y) && sample(x, y) < -90 && taken.every((t) => Math.hypot(x - t[0], (y - t[1]) * TY) > 150);
    for (let k = 0; k < NC; k++) if (forest[k] && sdf[k] > -40 && M.riverDist(cellX(k), cellY(k)) > 0) order.push(k);
    for (let k = 0; k < NC; k++) if (forest[k] && sdf[k] < -90 && M.riverDist(cellX(k), cellY(k)) > 0) order.push(k);
    for (let i = order.length - 1; i > 0; i--) { const j = (r() * (i + 1)) | 0; [order[i], order[j]] = [order[j], order[i]]; }
    for (const k of order) {
      const x = cellX(k) + (r() - 0.5) * SC, y = cellY(k) + (r() - 0.5) * SC, q = mir([x, y]), dp = sdf[k] < -90;
      if (dp ? !deep(x, y) || !deep(q[0], q[1]) : !fits(x, y) || !fits(q[0], q[1])) continue;
      taken.push([x, y], q);
      for (const [px, py] of [[x, y], q]) M.trees.push({ x: px, y: py, s: 0.72 + ((((px * 7 + py * 13) | 0) % 40) + 40) % 40 / 120 });
    }
  })();
  // 實體樹依縱深畫在地面之上：樹冠會蓋到商店建築（攤子與「奇珍」幡、商船的帆）的就不種。[x0, x1, y0, y1] 是相對商店的範圍
  const SHOP_BOX = { mystic: [-210, 270, -200, 155], ship: [-180, 180, -190, 120] };
  M.trees = M.trees.filter((t) => !M.shops.some(([sx, sy, k]) => { const b = SHOP_BOX[k]; return t.x > sx + b[0] && t.x < sx + b[1] && t.y > sy + b[2] && t.y < sy + b[3]; }));

  M.onFord = () => null;
  // pad > 0 是走路者（留出身體半徑）；pad = 0 是投射物
  M.walkable = (x, y, pad = 0) => inBounds(x, y) && sample(x, y) > pad;
  // 線段是否碰到林子：沿線以距離場步進（sphere tracing），不會跳過細窄的林角
  M.segClear = function (x0, y0, x1, y1, pad = 0) {
    if (!inBounds(x1, y1)) return false;
    const L = Math.hypot(x1 - x0, (y1 - y0) * TY);
    for (let t = 0; ; ) {
      const k = L ? Math.min(1, t / L) : 1, d = sample(x0 + (x1 - x0) * k, y0 + (y1 - y0) * k) - pad;
      if (d <= 0) return false;
      if (k >= 1) return true;
      t += Math.max(4, d * 0.9);
    }
  };
  // 沿距離場的梯度推出林子
  M.pushOut = function (x, y, pad = 0) {
    for (let it = 0; it < 8; it++) {
      const d = sample(x, y);
      if (d > pad) break;
      const gx = (sample(x + 4, y) - sample(x - 4, y)) / 8, gy = (sample(x, y + 4) - sample(x, y - 4)) / (8 * TY), g = Math.hypot(gx, gy);
      if (g < 1e-4) break;
      const m = pad - d + 0.5;
      x += (gx / g) * m; y += (gy / g) * m / TY;
    }
    return [Math.max(60, Math.min(W - 60, x)), Math.max(YMIN, Math.min(YMAX, y))];
  };
  // 最近的可走點：先沿梯度推出林子，還不行就往外一圈圈找
  M.nearestFree = function (x, y, pad = M.BODY) {
    const p = M.pushOut(x, y, pad);
    if (M.walkable(p[0], p[1], pad)) return p;
    for (let r = SC; r <= 900; r += SC) for (let a = 0; a < 24; a++) {
      const px = x + Math.cos((a * Math.PI) / 12) * r, py = y + Math.sin((a * Math.PI) / 12) * r * 0.7;
      if (M.walkable(px, py, pad)) return [px, py];
    }
    return [x, y];
  };

  // 從樹林深處走回路網的折線（每三格取一點；已經在路上就是空的）
  M.escape = function (x, y) {
    const ci = (x / SC) | 0, cj = (y / SC) | 0, out = [];
    let k = cj * SW + ci;
    // 格心落在樹裡時，改用直線走得到的鄰格
    for (let r = 1; toRoad[k] < 0 && r <= 2; r++) {
      let bd = 1e9;
      for (let j = cj - r; j <= cj + r; j++) for (let i = ci - r; i <= ci + r; i++) {
        const n = j * SW + i, px = (i + 0.5) * SC, py = (j + 0.5) * SC, d = Math.hypot(px - x, py - y);
        if (i >= 0 && j >= 0 && i < SW && j < SH && toRoad[n] >= 0 && d < bd && M.segClear(x, y, px, py, M.BODY)) { bd = d; k = n; }
      }
      if (toRoad[k] >= 0) out.push([(k % SW + 0.5) * SC, (((k / SW) | 0) + 0.5) * SC]);
    }
    for (let n = 0; toRoad[k] >= 0 && toRoad[k] !== k && n < 2000; n++) {
      k = toRoad[k];
      if (n % 3 === 2 || toRoad[k] === k) out.push([(k % SW + 0.5) * SC, (((k / SW) | 0) + 0.5) * SC]);
    }
    return out;
  };
  // 直線看得到的最近節點；看不到任何節點就回 null
  M.visibleNode = function (x, y) {
    const ks = Object.keys(M.nodes).map((k) => [k, Math.hypot(M.nodes[k][0] - x, M.nodes[k][1] - y)]).sort((a, b) => a[1] - b[1]);
    for (const [k, d] of ks) { if (d > 3000) break; if (M.segClear(x, y, M.nodes[k][0], M.nodes[k][1], M.BODY)) return k; }
    return null;
  };
  M.nearestNode = function (x, y) {
    let best = null, bd = 1e9;
    for (const k in M.nodes) { const n = M.nodes[k], d = Math.hypot(n[0] - x, n[1] - y); if (d < bd) { bd = d; best = k; } }
    return best;
  };
  // A*：起點與終點各自接上路網（看得到節點就直連，看不到就沿流場走出樹林），中間走導航圖
  M.path = function (x0, y0, x1, y1) {
    const head = [], tail = [];
    let s = M.visibleNode(x0, y0), g = M.visibleNode(x1, y1);
    if (!s) { head.push(...M.escape(x0, y0)); const e = head[head.length - 1]; s = (e && M.visibleNode(e[0], e[1])) || M.nearestNode(x0, y0); }
    if (!g) { tail.push(...M.escape(x1, y1).reverse()); const e = tail[0]; g = (e && M.visibleNode(e[0], e[1])) || M.nearestNode(x1, y1); }
    if (s === g) return [...head, M.nodes[s], ...tail, [x1, y1]];
    const open = new Set([s]), from = {}, gs = { [s]: 0 }, fs = { [s]: 0 };
    const h = (k) => Math.hypot(M.nodes[k][0] - M.nodes[g][0], M.nodes[k][1] - M.nodes[g][1]);
    while (open.size) {
      let cur = null, bf = 1e12;
      open.forEach((k) => { if (fs[k] < bf) { bf = fs[k]; cur = k; } });
      if (cur === g) break;
      open.delete(cur);
      for (const nb of M.adj[cur]) {
        const d = gs[cur] + Math.hypot(M.nodes[nb][0] - M.nodes[cur][0], M.nodes[nb][1] - M.nodes[cur][1]);
        if (gs[nb] === undefined || d < gs[nb]) { gs[nb] = d; fs[nb] = d + h(nb); from[nb] = cur; open.add(nb); }
      }
    }
    const mid = [];
    for (let k = g; k; k = k === s ? null : from[k]) mid.unshift(M.nodes[k]);
    return [...head, ...mid, ...tail, [x1, y1]];
  };

  // ---------- 地面繪製（依區塊快取） ----------
  function stroke(ctx, pts, w, col) {
    ctx.strokeStyle = col; ctx.lineWidth = w; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath(); pts.forEach((p, i) => (i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]))); ctx.stroke();
  }
  // 路線過江的三座浮橋：橋面沿著路線本身鋪（上下路剛好在轉角過江，橋面會跟著轉彎），兩端切齊江岸
  M.BRIDGE_HW = RHW + 70; // 橋面在江的法線方向上的半寬：蓋過水面，落在兩岸的沙地上
  M.bridges = Object.keys(M.lanes).map((lane) => {
    const pts = [];
    for (let s = 0; s <= M.laneLen[lane]; s += 6) { const p = M.laneAt(lane, s); if (Math.abs(M.riverDist(p[0], p[1])) < M.BRIDGE_HW + 40) pts.push(p); }
    const c = pts[pts.length >> 1] || [0, 0];
    return { lane, pts, x: c[0], y: c[1] };
  }).filter((b) => b.pts.length > 1);
  M.onBridge = (x, y) => Math.abs(M.riverDist(x, y)) < M.BRIDGE_HW && M.bridges.some((b) => { const L = M.lanes[b.lane]; for (let i = 0; i < L.length - 1; i++) if (segDist(x, y, L[i], L[i + 1]) < 92) return true; return false; });
  // ---------- 起伏地形（純視覺）：低頻高度場，光從左上來，向光坡亮、背光坡暗 ----------
  function noise(seed, scale) {
    const lat = new Map(), r = rng(seed);
    const hv = (i, j) => { const k = i * 4096 + j; if (!lat.has(k)) lat.set(k, r()); return lat.get(k); };
    return (x, y) => {
      const fx = x / scale, fy = y / scale, i = Math.floor(fx), j = Math.floor(fy), u = fx - i, v = fy - j, su = u * u * (3 - 2 * u), sv = v * v * (3 - 2 * v);
      return (hv(i, j) * (1 - su) + hv(i + 1, j) * su) * (1 - sv) + (hv(i, j + 1) * (1 - su) + hv(i + 1, j + 1) * su) * sv;
    };
  }
  const HN1 = noise(4417, 760), HN2 = noise(9029, 300);
  const h0 = (x, y) => HN1(x, y) * 0.7 + HN2(x, y) * 0.3;
  M.heightAt = (x, y) => { const q = mir([x, y]); return (h0(x, y) + h0(q[0], q[1])) / 2; }; // 點對稱
  const LIGHT = (() => { const l = [-0.55, -0.7, 0.62], n = Math.hypot(...l); return l.map((v) => v / n); })();
  const RC = 16, RELIEF = 420; // 取樣間距、起伏高度（世界單位）
  function paintRelief(ctx, x0, y0, w, h) {
    if (typeof document === 'undefined') return;
    const cw = Math.ceil(w / RC) + 2, ch = Math.ceil(h / RC) + 2, ox = Math.floor(x0 / RC) * RC - RC, oy = Math.floor(y0 / RC) * RC - RC;
    const c = document.createElement('canvas'); c.width = cw; c.height = ch;
    const g = c.getContext('2d'), img = g.createImageData(cw, ch), D = img.data;
    for (let j = 0; j < ch; j++) for (let i = 0; i < cw; i++) {
      const x = ox + i * RC, y = oy + j * RC, k = (j * cw + i) * 4;
      if (Math.abs(M.riverDist(x, y)) < RHW + 6 || M.shallowAt(x, y)) { D[k + 3] = 0; continue; } // 水面不打光
      const hx = (M.heightAt(x + RC, y) - M.heightAt(x - RC, y)) * RELIEF / (2 * RC);
      const hy = (M.heightAt(x, y + RC) - M.heightAt(x, y - RC)) * RELIEF / (2 * RC * TY);
      const n = Math.hypot(hx, hy, 1), dot = (-hx * LIGHT[0] - hy * LIGHT[1] + LIGHT[2]) / n - LIGHT[2];
      const low = (0.5 - M.heightAt(x, y)) * 0.18; // 低窪處略暗
      const v = dot * 1.9 - low;
      if (v > 0) { D[k] = 255; D[k + 1] = 238; D[k + 2] = 196; D[k + 3] = Math.min(105, v * 255); }
      else { D[k] = 10; D[k + 1] = 18; D[k + 2] = 12; D[k + 3] = Math.min(140, -v * 255); }
    }
    g.putImageData(img, 0, 0);
    ctx.save(); ctx.imageSmoothingEnabled = true; ctx.drawImage(c, ox - RC / 2, oy - RC / 2, cw * RC, ch * RC); ctx.restore();
  }

  // ---------- 林塊（畫成一塊有高度的方塊）----------
  // 頂面：樹冠，從南緣往北退 LIFT；正面：南緣露出一條樹幹牆；林緣往右下投影
  const CAN = 34, LIFT = 46;
  // 太窄的林帶（北邊沒有足夠縱深）不做高度，免得只剩一排光禿禿的樹幹
  const thin = (x, y) => sample(x, y - LIFT) > -10;
  function paintForest(ctx, x0, y0, w, h) {
    const i0 = Math.floor((x0 - 60) / CAN), i1 = Math.ceil((x0 + w + 60) / CAN), j0 = Math.floor((y0 - 60) / CAN), j1 = Math.ceil((y0 + h + 120) / CAN);
    const pts = [];
    for (let j = j0; j <= j1; j++) for (let i = i0; i <= i1; i++) {
      const rr = rng(i * 92821 + j * 68917 + 3), x = (i + rr()) * CAN, y = (j + rr()) * CAN, d = sample(x, y);
      pts.push([x, y, d, thin(x, y) ? d : Math.max(d, sample(x, y + LIFT)), rr(), rr(), rr()]);
    }
    // 投影：林子往右下方落影
    for (const [x, y, d, , a] of pts) if (d > -10 && d < 60) {
      ctx.fillStyle = `rgba(12,20,10,${(0.2 * (1 - Math.max(0, d) / 60)).toFixed(3)})`;
      ctx.beginPath(); ctx.ellipse(x + 16, y + 14, 32 + a * 10, 20 + a * 6, 0, 0, Math.PI * 2); ctx.fill();
    }
    // 林地底色
    ctx.fillStyle = '#16221a';
    for (const [x, y, d] of pts) if (d < -4) { ctx.beginPath(); ctx.arc(x, y, Math.min(34, 10 + -d * 0.6), 0, Math.PI * 2); ctx.fill(); }
    // 正面：南緣的樹幹牆（固定的直欄，跨區塊也對得上）
    const cx0 = Math.floor((x0 - 20) / 11), cx1 = Math.ceil((x0 + w + 20) / 11);
    for (let ci = cx0; ci <= cx1; ci++) {
      const rr = rng(ci * 7919 + 11), x = ci * 11 + rr() * 4, tw = 3 + rr() * 2.5, col = rr() < 0.5 ? '#3a2a1c' : '#2c2015';
      if (rr() < 0.3) continue; // 樹幹之間留空，看得到後面的暗處
      for (let y = Math.floor((y0 - LIFT) / 5) * 5; y < y0 + h + 6; y += 5) {
        const d = sample(x, y);
        if (d > -3 || sample(x, y + LIFT) < -6 || thin(x, y)) continue;
        const q = Math.max(0, Math.min(1, (-sample(x, y + LIFT) + 6) / 30)); // 越靠樹冠越暗
        ctx.fillStyle = col; ctx.globalAlpha = 0.95 - q * 0.5; ctx.fillRect(x - tw / 2, y, tw, 5.5);
      }
    }
    ctx.globalAlpha = 1;
    // 頂面：樹冠
    const crowns = pts.filter((p) => p[3] < -8).map(([x, y, d, e, a, b, c]) => [x, y, Math.min(40, 14 + -e * 0.5) * (0.8 + a * 0.35), b, c]);
    const DARK = ['#1a2a1b', '#1c2f1a', '#182818'], MIDC = ['#2b452c', '#2f4a2b', '#294227'], LITE = ['#3d5f39', '#44673d', '#3a5934'];
    for (const [x, y, rad, b] of crowns) { ctx.fillStyle = DARK[(b * 3) | 0]; ctx.beginPath(); ctx.arc(x + 4, y + 7, rad, 0, Math.PI * 2); ctx.fill(); }
    for (const [x, y, rad, b] of crowns) { ctx.fillStyle = MIDC[(b * 3) | 0]; ctx.beginPath(); ctx.arc(x, y, rad * 0.86, 0, Math.PI * 2); ctx.fill(); }
    for (const [x, y, rad, b, c] of crowns) {
      ctx.fillStyle = LITE[(c * 3) | 0]; ctx.beginPath(); ctx.arc(x - rad * 0.22, y - rad * 0.26, rad * 0.5, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(200,225,150,.18)'; ctx.beginPath(); ctx.arc(x - rad * 0.32, y - rad * 0.38, rad * 0.22, 0, Math.PI * 2); ctx.fill();
    }
    ctx.strokeStyle = 'rgba(12,20,10,.35)'; ctx.lineWidth = 1.6;
    for (const [x, y, rad] of crowns) { ctx.beginPath(); ctx.arc(x, y, rad * 0.86, 0.15 * Math.PI, 0.85 * Math.PI); ctx.stroke(); }
    // 頂面的南緣：樹冠下緣的陰影壓在樹幹牆上
    for (const [x, y, d, e] of pts) if (e < -6 && e > -30 && !thin(x, y) && sample(x, y + LIFT + 14) > -4) {
      ctx.fillStyle = 'rgba(8,14,8,.45)'; ctx.beginPath(); ctx.ellipse(x, y + 18, 26, 8, 0, 0, Math.PI); ctx.fill();
    }
    // 北緣受光的亮邊
    ctx.strokeStyle = 'rgba(205,230,150,.32)'; ctx.lineWidth = 2.4;
    for (const [x, y, rad] of crowns) if (sample(x, y - rad - 6) > -2) { ctx.beginPath(); ctx.arc(x, y, rad * 0.84, 1.15 * Math.PI, 1.85 * Math.PI); ctx.stroke(); }
  }

  M.paint = function (ctx, x0, y0, w, h) {
    ctx.save();
    ctx.beginPath(); ctx.rect(x0, y0, w, h); ctx.clip();
    ctx.fillStyle = '#4d5a36'; ctx.fillRect(x0, y0, w, h);
    const r = rng(((x0 / 64) | 0) * 7919 + ((y0 / 64) | 0) * 104729 + 7);
    for (let i = 0; i < 60; i++) {
      ctx.fillStyle = r() < 0.5 ? 'rgba(80,98,52,.55)' : 'rgba(60,72,40,.5)';
      ctx.beginPath(); ctx.ellipse(x0 + r() * w, y0 + r() * h, 20 + r() * 60, 8 + r() * 24, 0, 0, Math.PI * 2); ctx.fill();
    }
    // 草叢筆觸與碎石
    ctx.lineWidth = 1.6; ctx.lineCap = 'round';
    for (let i = 0; i < 90; i++) {
      const x = x0 + r() * w, y = y0 + r() * h;
      if (Math.abs(M.riverDist(x, y)) < RHW + 40) continue;
      ctx.strokeStyle = r() < 0.5 ? 'rgba(120,150,70,.55)' : 'rgba(46,62,30,.6)';
      ctx.beginPath(); ctx.moveTo(x - 4, y); ctx.lineTo(x - 1, y - 9); ctx.moveTo(x, y); ctx.lineTo(x + 2, y - 11); ctx.moveTo(x + 4, y); ctx.lineTo(x + 7, y - 8); ctx.stroke();
    }
    // 野區小徑（導航線），讓樹林裡的通道看得出來
    M.edges.forEach(([a, b]) => stroke(ctx, [M.nodes[a], M.nodes[b]], 70, 'rgba(112,100,66,.35)'));
    // 營地空地與本營廣場
    M.camps.forEach((c) => { ctx.fillStyle = 'rgba(122,100,66,.8)'; ctx.beginPath(); ctx.ellipse(c.x, c.y, 170, 90, 0, 0, Math.PI * 2); ctx.fill(); });
    M.bases.forEach((b, i) => {
      ctx.fillStyle = '#6f6a60'; ctx.beginPath(); ctx.ellipse(b.x + (i ? -60 : 60), b.y, 460, 320, 0, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(40,36,30,.35)'; ctx.lineWidth = 2;
      for (let k = -260; k <= 260; k += 52) { ctx.beginPath(); ctx.moveTo(b.x - 460, b.y + k); ctx.lineTo(b.x + 460, b.y + k); ctx.stroke(); }
      ctx.strokeStyle = i ? 'rgba(74,116,196,.55)' : 'rgba(240,180,60,.5)'; ctx.lineWidth = 4; ctx.setLineDash([16, 12]);
      ctx.beginPath(); ctx.arc(b.x, b.y, M.shopR, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
      // 溫泉池：守方回血、攻方受傷
      const px = b.x + (i ? 170 : -170), py = b.y + (i ? -150 : 170);
      ctx.fillStyle = '#6f6a60';
      for (let a = 0; a < Math.PI * 2; a += 0.35) { ctx.beginPath(); ctx.ellipse(px + Math.cos(a) * 118, py + Math.sin(a) * 66, 16, 10, 0, 0, Math.PI * 2); ctx.fill(); }
      const pg = ctx.createRadialGradient(px, py, 10, px, py, 115);
      pg.addColorStop(0, '#9fe0d8'); pg.addColorStop(1, '#3f8a8a');
      ctx.fillStyle = pg; ctx.beginPath(); ctx.ellipse(px, py, 110, 60, 0, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,.45)'; ctx.lineWidth = 2;
      for (let k = 0; k < 5; k++) { const sx = px - 60 + k * 30; ctx.beginPath(); ctx.moveTo(sx, py - 10); ctx.bezierCurveTo(sx - 10, py - 40, sx + 10, py - 60, sx, py - 90); ctx.stroke(); }
      ctx.fillStyle = 'rgba(236,228,210,.85)'; ctx.font = '900 26px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('溫泉', px, py + 96);
    });
    // 神秘商店的空地與購買範圍（攤子本身等樹林畫完再畫，見下面）
    M.shops.forEach(([sx, sy, kind]) => {
      if (kind === 'ship') return;
      const R = M.SHOP_R.mystic;
      ctx.fillStyle = 'rgba(122,100,66,.85)'; ctx.beginPath(); ctx.ellipse(sx, sy, R + 10, R * 0.8, 0, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(233,196,106,.6)'; ctx.lineWidth = 4; ctx.setLineDash([14, 10]); ctx.beginPath(); ctx.arc(sx, sy, R - 8, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
    });
    // 路
    Object.values(M.lanes).forEach((L) => { stroke(ctx, L, 190, '#7b6746'); stroke(ctx, L, 160, '#8e7750'); stroke(ctx, L, 4, 'rgba(60,44,28,.25)'); });
    // 路面：車轍與碎石
    Object.values(M.lanes).forEach((L) => {
      ctx.strokeStyle = 'rgba(60,44,28,.18)'; ctx.lineWidth = 3;
      for (let i = 0; i < L.length - 1; i++) {
        const a = L[i], b = L[i + 1], dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy), nx = -dy / len, ny = dx / len;
        for (const off of [-34, 34]) { ctx.beginPath(); ctx.moveTo(a[0] + nx * off, a[1] + ny * off); ctx.lineTo(b[0] + nx * off, b[1] + ny * off); ctx.stroke(); }
      }
      ctx.strokeStyle = 'rgba(210,190,150,.35)'; ctx.lineWidth = 2;
      for (let i = 0; i < L.length - 1; i++) {
        const a = L[i], b = L[i + 1], dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy), nx = -dy / len, ny = dx / len;
        ctx.beginPath(); ctx.moveTo(a[0] + nx * -78, a[1] + ny * -78); ctx.lineTo(b[0] + nx * -78, b[1] + ny * -78); ctx.stroke();
      }
    });
    for (let i = 0; i < 40; i++) {
      const x = x0 + r() * w, y = y0 + r() * h;
      let onRoad = false;
      for (const L of Object.values(M.lanes)) for (let k = 0; k < L.length - 1 && !onRoad; k++) if (segDist(x, y, L[k], L[k + 1]) < 70) onRoad = true;
      if (!onRoad) continue;
      ctx.fillStyle = r() < 0.5 ? 'rgba(120,100,70,.6)' : 'rgba(170,150,110,.6)'; ctx.beginPath(); ctx.ellipse(x, y, 3 + r() * 4, 2 + r() * 2, r(), 0, Math.PI * 2); ctx.fill();
    }
    // 長江（淺灘，可以涉水）：兩岸是低於高地的崖壁
    const RV = [M.river.a, M.river.b];
    ctx.lineCap = 'butt';
    stroke(ctx, RV, RHW * 2 + 210, '#3e4a2c'); stroke(ctx, RV, RHW * 2 + 176, '#6d5a3a'); stroke(ctx, RV, RHW * 2 + 150, '#8a7448');
    stroke(ctx, RV, RHW * 2 + 70, '#9a8a62'); stroke(ctx, RV, RHW * 2 + 10, '#50707e'); stroke(ctx, RV, RHW * 1.3, '#3f6173');
    // 崖壁的岩塊
    for (let i = 0; i < 70; i++) {
      const x = x0 + r() * w, y = y0 + r() * h, d = Math.abs(M.riverDist(x, y));
      if (d < RHW + 40 || d > RHW + 100) continue;
      const rr = 5 + r() * 9;
      ctx.fillStyle = r() < 0.5 ? '#5a4a30' : '#7c6642'; ctx.beginPath(); ctx.moveTo(x - rr, y + rr * 0.4); ctx.lineTo(x - rr * 0.5, y - rr * 0.6); ctx.lineTo(x + rr * 0.4, y - rr * 0.8); ctx.lineTo(x + rr, y + rr * 0.2); ctx.closePath(); ctx.fill();
      ctx.strokeStyle = 'rgba(30,22,14,.5)'; ctx.lineWidth = 1.2; ctx.stroke();
    }
    ctx.strokeStyle = 'rgba(210,230,240,.3)'; ctx.lineWidth = 2;
    for (let i = 0; i < 40; i++) {
      const x = x0 + r() * w, y = y0 + r() * h;
      if (Math.abs(M.riverDist(x, y)) > RHW - 14) continue;
      ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + 18, y + 14); ctx.stroke();
    }
    // 呂布的沙洲
    ctx.fillStyle = '#9a8a62'; ctx.beginPath(); ctx.ellipse(M.island.x, M.island.y, M.island.r + 40, (M.island.r + 40) * 0.8, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#5b6038'; ctx.beginPath(); ctx.ellipse(M.island.x, M.island.y, M.island.r, M.island.r * 0.8, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = 'rgba(40,30,24,.6)'; ctx.lineWidth = 6; ctx.setLineDash([22, 14]);
    ctx.beginPath(); ctx.ellipse(M.island.x, M.island.y, M.island.r - 36, (M.island.r - 36) * 0.8, 0, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
    // 浮橋：沿路線鋪橋面，裁在江岸兩條平行線之間，木板垂直於路線，兩側有欄杆
    const nx = -RS / RN, ny = 1 / RN, ux = 1 / RN, uy = RS / RN, BH = M.BRIDGE_HW;
    const bandPath = () => { ctx.beginPath(); ctx.moveTo(M.river.a[0] + nx * BH, M.river.a[1] + ny * BH); ctx.lineTo(M.river.b[0] + nx * BH, M.river.b[1] + ny * BH); ctx.lineTo(M.river.b[0] - nx * BH, M.river.b[1] - ny * BH); ctx.lineTo(M.river.a[0] - nx * BH, M.river.a[1] - ny * BH); ctx.closePath(); };
    M.bridges.forEach((b) => {
      const P = b.pts, nrm = (i) => { const a = P[Math.max(0, i - 1)], c = P[Math.min(P.length - 1, i + 1)], dx = c[0] - a[0], dy = c[1] - a[1], l = Math.hypot(dx, dy) || 1; return [-dy / l, dx / l]; };
      const side = (o) => P.map((p, i) => { const n = nrm(i); return [p[0] + n[0] * o, p[1] + n[1] * o]; });
      ctx.save(); bandPath(); ctx.clip();
      ctx.lineCap = 'butt'; ctx.lineJoin = 'round';
      stroke(ctx, P, 196, 'rgba(10,20,26,.45)'); // 橋下陰影
      stroke(ctx, P, 184, '#6b4a2e');
      ctx.strokeStyle = 'rgba(27,20,17,.55)'; ctx.lineWidth = 3;
      for (let i = 0; i < P.length; i += 4) { const n = nrm(i), p = P[i]; ctx.beginPath(); ctx.moveTo(p[0] + n[0] * 92, p[1] + n[1] * 92); ctx.lineTo(p[0] - n[0] * 92, p[1] - n[1] * 92); ctx.stroke(); }
      stroke(ctx, side(-92), 6, '#3e2a1a'); stroke(ctx, side(92), 6, '#3e2a1a');
      ctx.restore();
      // 橋頭：兩岸各一排木樁，順著江岸方向
      for (const sgn of [1, -1]) {
        const e = P.reduce((best, p) => (Math.abs(M.riverDist(p[0], p[1]) - sgn * BH) < Math.abs(M.riverDist(best[0], best[1]) - sgn * BH) ? p : best), P[0]);
        const ex = e[0] - nx * (M.riverDist(e[0], e[1]) - sgn * BH), ey = e[1] - ny * (M.riverDist(e[0], e[1]) - sgn * BH);
        for (const k of [-1, 1]) { const px = ex + ux * k * 100, py = ey + uy * k * 100; ctx.fillStyle = '#3e2a1a'; ctx.beginPath(); ctx.ellipse(px, py, 9, 6, 0, 0, Math.PI * 2); ctx.fill(); ctx.fillStyle = '#6b4a2e'; ctx.beginPath(); ctx.ellipse(px, py - 3, 7, 4.5, 0, 0, Math.PI * 2); ctx.fill(); }
      }
    });
    // 淺灘：一圈濕沙，中間淺水與幾道水紋
    M.shallows.forEach((b) => {
      ctx.fillStyle = '#8a7a52'; ctx.beginPath(); ctx.ellipse(b[0], b[1], b[2] + 18, b[3] + 13, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#5d7a80'; ctx.beginPath(); ctx.ellipse(b[0], b[1], b[2], b[3], 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(63,97,115,.75)'; ctx.beginPath(); ctx.ellipse(b[0], b[1], b[2] * 0.62, b[3] * 0.62, 0, 0, Math.PI * 2); ctx.fill();
      const rr = rng(b[0] * 17 + b[1]);
      ctx.strokeStyle = 'rgba(210,230,240,.35)'; ctx.lineWidth = 2; ctx.lineCap = 'round';
      for (let i = 0; i < 7; i++) { const a = rr() * Math.PI * 2, d = Math.sqrt(rr()) * 0.75, x = b[0] + Math.cos(a) * b[2] * d, y = b[1] + Math.sin(a) * b[3] * d; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + 16, y + 6); ctx.stroke(); }
    });
    // 蘆葦
    M.brush.forEach((b) => {
      ctx.fillStyle = 'rgba(96,104,58,.7)'; ctx.beginPath(); ctx.ellipse(b[0], b[1], b[2], b[3], 0, 0, Math.PI * 2); ctx.fill();
      const rr = rng(b[0] * 31 + b[1]);
      ctx.lineWidth = 2; ctx.lineCap = 'round';
      for (let i = 0; i < 140; i++) {
        const a = rr() * Math.PI * 2, d = Math.sqrt(rr()), x = b[0] + Math.cos(a) * b[2] * d, y = b[1] + Math.sin(a) * b[3] * d;
        ctx.strokeStyle = rr() < 0.5 ? '#a39a66' : '#6e6a45';
        ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + (rr() - 0.5) * 8, y - 18 - rr() * 16); ctx.stroke();
      }
    });
    paintRelief(ctx, x0, y0, w, h);
    paintForest(ctx, x0, y0, w, h);
    // 神秘商店：方士的奇珍攤。瓦頂小亭、紫幔、櫃上擺葫蘆丹罐，旁邊豎「奇珍」幡。畫在樹林之後，才不會被樹擋住
    M.shops.forEach(([sx, sy, kind]) => {
      if (kind === 'ship') return;
      ctx.fillStyle = 'rgba(20,14,10,.35)'; ctx.beginPath(); ctx.ellipse(sx + 8, sy + 16, 130, 30, 0, 0, Math.PI * 2); ctx.fill();
      // 後牆與紫幔，架上的丹罐
      ctx.fillStyle = '#5a3a24'; ctx.fillRect(sx - 92, sy - 96, 184, 100);
      ctx.fillStyle = '#3d2a4a'; ctx.fillRect(sx - 82, sy - 90, 164, 62);
      ctx.strokeStyle = 'rgba(201,162,255,.35)'; ctx.lineWidth = 2;
      for (let k = -60; k <= 60; k += 30) { ctx.beginPath(); ctx.moveTo(sx + k, sy - 90); ctx.quadraticCurveTo(sx + k + 8, sy - 60, sx + k, sy - 28); ctx.stroke(); }
      ctx.fillStyle = '#4a2f1c'; ctx.fillRect(sx - 82, sy - 62, 164, 5);
      [['#3f7a6a', -60], ['#a8443a', -30], ['#c9a24a', 0], ['#5a6fa8', 30], ['#3f7a6a', 58]].forEach(([c, k]) => { ctx.fillStyle = c; ctx.beginPath(); ctx.ellipse(sx + k, sy - 70, 8, 9, 0, 0, Math.PI * 2); ctx.fill(); ctx.fillRect(sx + k - 3, sy - 82, 6, 5); });
      // 柱子
      ctx.fillStyle = '#8a2a22'; ctx.fillRect(sx - 104, sy - 100, 14, 112); ctx.fillRect(sx + 90, sy - 100, 14, 112);
      ctx.fillStyle = '#2a1a14'; ctx.fillRect(sx - 108, sy + 6, 22, 8); ctx.fillRect(sx + 86, sy + 6, 22, 8);
      // 瓦頂：兩端起翹，屋脊兩頭鴟吻
      ctx.fillStyle = '#2b2f36'; ctx.beginPath(); ctx.moveTo(sx - 158, sy - 112); ctx.quadraticCurveTo(sx - 116, sy - 104, sx - 96, sy - 146); ctx.lineTo(sx + 96, sy - 146); ctx.quadraticCurveTo(sx + 116, sy - 104, sx + 158, sy - 112); ctx.lineTo(sx + 124, sy - 94); ctx.lineTo(sx - 124, sy - 94); ctx.closePath(); ctx.fill();
      ctx.strokeStyle = '#14161a'; ctx.lineWidth = 3; ctx.stroke();
      ctx.strokeStyle = 'rgba(160,170,180,.3)'; ctx.lineWidth = 2;
      for (let k = -100; k <= 100; k += 20) { ctx.beginPath(); ctx.moveTo(sx + k * 0.82, sy - 144); ctx.lineTo(sx + k * 1.18, sy - 96); ctx.stroke(); }
      ctx.fillStyle = '#1e2126'; ctx.fillRect(sx - 100, sy - 156, 200, 12);
      for (const d of [-1, 1]) { ctx.beginPath(); ctx.moveTo(sx + d * 100, sy - 156); ctx.quadraticCurveTo(sx + d * 116, sy - 160, sx + d * 112, sy - 176); ctx.lineTo(sx + d * 100, sy - 144); ctx.closePath(); ctx.fill(); }
      // 簷角燈籠
      for (const d of [-1, 1]) {
        const lx = sx + d * 140, ly = sy - 80;
        ctx.strokeStyle = '#2a1a14'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(lx, sy - 104); ctx.lineTo(lx, ly - 12); ctx.stroke();
        ctx.fillStyle = 'rgba(255,170,80,.28)'; ctx.beginPath(); ctx.arc(lx, ly, 22, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = '#c4302a'; ctx.beginPath(); ctx.ellipse(lx, ly, 9, 12, 0, 0, Math.PI * 2); ctx.fill();
      }
      // 櫃台與貨：葫蘆、丹爐、竹簡、會發光的寶珠
      ctx.fillStyle = '#6b4a2e'; ctx.fillRect(sx - 112, sy - 28, 224, 40);
      ctx.fillStyle = '#8a6a42'; ctx.fillRect(sx - 118, sy - 34, 236, 9);
      ctx.strokeStyle = 'rgba(42,26,20,.5)'; ctx.lineWidth = 2; for (let k = -80; k <= 80; k += 40) { ctx.beginPath(); ctx.moveTo(sx + k, sy - 24); ctx.lineTo(sx + k, sy + 10); ctx.stroke(); }
      ctx.fillStyle = '#c9a24a'; ctx.beginPath(); ctx.arc(sx - 74, sy - 44, 11, 0, Math.PI * 2); ctx.arc(sx - 74, sy - 62, 7, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#7a2f26'; ctx.fillRect(sx - 76, sy - 72, 4, 5);
      ctx.fillStyle = '#5c5a52'; ctx.beginPath(); ctx.moveTo(sx - 36, sy - 34); ctx.lineTo(sx - 30, sy - 56); ctx.lineTo(sx - 6, sy - 56); ctx.lineTo(sx, sy - 34); ctx.closePath(); ctx.fill(); ctx.fillRect(sx - 34, sy - 62, 32, 6);
      ctx.fillStyle = '#d9c39a'; ctx.fillRect(sx + 16, sy - 46, 36, 12); ctx.strokeStyle = '#6b4a2e'; ctx.lineWidth = 1.5; for (let k = 22; k < 52; k += 6) { ctx.beginPath(); ctx.moveTo(sx + k, sy - 46); ctx.lineTo(sx + k, sy - 34); ctx.stroke(); }
      ctx.fillStyle = 'rgba(160,200,255,.3)'; ctx.beginPath(); ctx.arc(sx + 80, sy - 48, 20, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#9ec8ff'; ctx.beginPath(); ctx.arc(sx + 80, sy - 48, 10, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,.8)'; ctx.beginPath(); ctx.arc(sx + 76, sy - 52, 3, 0, Math.PI * 2); ctx.fill();
      // 「奇珍」幡
      const fx = sx + 168;
      ctx.strokeStyle = '#2a1a14'; ctx.lineWidth = 5; ctx.beginPath(); ctx.moveTo(fx, sy + 20); ctx.lineTo(fx, sy - 172); ctx.stroke();
      ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(fx, sy - 166); ctx.lineTo(fx + 48, sy - 166); ctx.stroke();
      ctx.fillStyle = '#d9c39a'; ctx.beginPath(); ctx.moveTo(fx + 4, sy - 164); ctx.lineTo(fx + 46, sy - 164); ctx.lineTo(fx + 46, sy - 44); ctx.lineTo(fx + 25, sy - 56); ctx.lineTo(fx + 4, sy - 44); ctx.closePath(); ctx.fill();
      ctx.strokeStyle = '#6b4a2e'; ctx.lineWidth = 2; ctx.stroke();
      ctx.fillStyle = '#7a2f26'; ctx.font = '900 30px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('奇', fx + 25, sy - 134); ctx.fillText('珍', fx + 25, sy - 94); ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = 'rgba(236,228,210,.9)'; ctx.font = '900 24px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('神秘商店', sx, sy + 50);
    });
    // 長江商船：船身順著江流泊著，樓艙、硬帆、船頭船尾各一盞燈籠。也畫在樹林之後
    M.shops.forEach(([sx, sy, kind]) => {
      if (kind !== 'ship') return;
      ctx.strokeStyle = 'rgba(233,196,106,.6)'; ctx.lineWidth = 4; ctx.setLineDash([14, 10]); ctx.beginPath(); ctx.arc(sx, sy, M.SHOP_R.ship - 6, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
      // 購買範圍小，船也畫小一點，船頭船尾剛好在虛線圈上
      ctx.save(); ctx.translate(sx, sy); ctx.scale(0.72, 0.72); ctx.translate(-sx, -sy);
      ctx.save(); ctx.translate(sx, sy); ctx.rotate(Math.atan2(uy, ux));
      ctx.fillStyle = 'rgba(10,20,26,.4)'; ctx.beginPath(); ctx.ellipse(6, 10, 170, 50, 0, 0, Math.PI * 2); ctx.fill();
      const hull = (s) => { ctx.beginPath(); ctx.moveTo(-130 * s, -40 * s); ctx.lineTo(110 * s, -40 * s); ctx.quadraticCurveTo(175 * s, 0, 110 * s, 40 * s); ctx.lineTo(-130 * s, 40 * s); ctx.quadraticCurveTo(-160 * s, 0, -130 * s, -40 * s); ctx.closePath(); };
      hull(1); ctx.fillStyle = '#4a2f1c'; ctx.fill(); ctx.strokeStyle = '#1e140e'; ctx.lineWidth = 4; ctx.stroke();
      hull(0.82); ctx.fillStyle = '#8a6a42'; ctx.fill();
      ctx.strokeStyle = 'rgba(42,26,20,.45)'; ctx.lineWidth = 2;
      for (let k = -100; k <= 110; k += 22) { ctx.beginPath(); ctx.moveTo(k, -30); ctx.lineTo(k, 30); ctx.stroke(); }
      ctx.fillStyle = '#7a2f26'; ctx.fillRect(-105, -26, 100, 52); ctx.strokeStyle = '#2a1a14'; ctx.lineWidth = 3; ctx.strokeRect(-105, -26, 100, 52);
      ctx.fillStyle = '#a8443a'; ctx.fillRect(-97, -18, 84, 36);
      ctx.restore();
      // 帆與燈籠立在畫面上（不跟著船身轉）
      const mx = sx + ux * 45, my = sy + uy * 45;
      ctx.strokeStyle = '#2a1a14'; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(mx, my); ctx.lineTo(mx, my - 210); ctx.stroke();
      ctx.fillStyle = '#d9c39a'; ctx.beginPath(); ctx.moveTo(mx - 62, my - 196); ctx.lineTo(mx + 54, my - 196); ctx.lineTo(mx + 70, my - 64); ctx.lineTo(mx - 76, my - 64); ctx.closePath(); ctx.fill();
      ctx.strokeStyle = '#6b4a2e'; ctx.lineWidth = 3; ctx.stroke();
      for (let k = 1; k < 4; k++) { const t = k / 4, y = my - 196 + 132 * t; ctx.beginPath(); ctx.moveTo(mx - 62 - 14 * t, y); ctx.lineTo(mx + 54 + 16 * t, y); ctx.stroke(); }
      ctx.fillStyle = '#7a2f26'; ctx.font = '900 46px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('商', mx - 3, my - 130); ctx.textBaseline = 'alphabetic';
      for (const k of [-140, 150]) {
        const lx = sx + ux * k, ly = sy + uy * k - 34;
        ctx.strokeStyle = '#2a1a14'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(lx, ly + 34); ctx.lineTo(lx, ly - 10); ctx.stroke();
        ctx.fillStyle = 'rgba(255,170,80,.3)'; ctx.beginPath(); ctx.arc(lx, ly, 24, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = '#c4302a'; ctx.beginPath(); ctx.ellipse(lx, ly, 10, 13, 0, 0, Math.PI * 2); ctx.fill();
      }
      ctx.restore();
      ctx.fillStyle = 'rgba(236,228,210,.9)'; ctx.font = '900 24px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('長江商船', sx, sy + 70);
    });
    ctx.restore();
  };

  // 樹：以實體方式畫，才能依前後縱深遮擋角色
  M.drawTree = function (ctx, t, alpha) {
    const s = t.s;
    ctx.save(); ctx.translate(t.x, t.y); ctx.scale(s, s);
    if (alpha < 1) ctx.globalAlpha = alpha;
    SG.draw.castShadow(ctx, 0, 4, 46, 13, 130, 0.3);
    const v = t.v == null ? (t.v = ((t.x * 13 + t.y * 7) | 0) % 3) : t.v;
    const blob = (x, y, r, c) => { ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); SG.draw.ink(ctx, c, 2.4); };
    if (v === 2) {
      // 松：層層疊的三角樹冠
      SG.draw.caps(ctx, [[[0, 4], [0, -40], 11, '#5b3d27']]);
      [[-46, -36, 46, 56], [-40, -66, 40, 84], [-32, -94, 32, 108], [-20, -118, 20, 132]].forEach(([x0, yb, x1, yt], i) => SG.draw.poly(ctx, [[x0, -yb], [0, -yt], [x1, -yb]], i % 2 ? '#2c4a2c' : '#345a32', 2.4));
      ctx.fillStyle = 'rgba(170,200,120,.22)'; ctx.beginPath(); ctx.moveTo(-6, -126); ctx.lineTo(0, -132); ctx.lineTo(4, -112); ctx.lineTo(-10, -104); ctx.closePath(); ctx.fill();
    } else {
      SG.draw.caps(ctx, [[[0, 4], [0, -46], 12, '#5b3d27']]);
      ctx.strokeStyle = 'rgba(30,18,10,.4)'; ctx.lineWidth = 1.4; ctx.beginPath(); ctx.moveTo(-3, 0); ctx.lineTo(-2, -36); ctx.moveTo(3, -4); ctx.lineTo(3, -30); ctx.stroke();
      if (v === 1) { blob(-30, -66, 28, '#2a4628'); blob(30, -68, 28, '#2a4628'); blob(-12, -100, 30, '#3a5a30'); blob(16, -98, 32, '#3f6436'); }
      else { blob(-24, -70, 30, '#2f4a2a'); blob(24, -72, 30, '#2f4a2a'); blob(0, -96, 36, '#3a5a30'); }
      // 樹冠下緣的陰影與頂部亮點
      ctx.fillStyle = 'rgba(14,26,14,.35)'; ctx.beginPath(); ctx.ellipse(0, -56, 44, 12, 0, 0, Math.PI); ctx.fill();
      ctx.fillStyle = 'rgba(180,210,130,.28)'; ctx.beginPath(); ctx.arc(-10, -108, 14, 0, Math.PI * 2); ctx.arc(14, -102, 8, 0, Math.PI * 2); ctx.fill();
    }
    ctx.restore();
  };

  // 黃巾營地：黃帳篷與「黃」字大旗；渠帥的營地帳篷大一號、旗子也大
  M.drawCamp = function (ctx, c) {
    const { poly, caps } = SG.draw, big = c.kind === 'bandit', k = big ? 1.2 : 1;
    ctx.save(); ctx.translate(c.x + 90, c.y - 40); ctx.scale(k, k);
    poly(ctx, [[-40, 0], [0, -56], [40, 0]], big ? '#c9962a' : '#d8b04a');
    ctx.strokeStyle = 'rgba(90,60,20,.45)'; ctx.lineWidth = 1.6; ctx.beginPath(); ctx.moveTo(-20, 0); ctx.lineTo(0, -56); ctx.lineTo(20, 0); ctx.stroke();
    poly(ctx, [[-10, 0], [0, -30], [10, 0]], '#2a2420', 1.6);
    caps(ctx, [[[48, 0], [48, -86], 2.6, '#3a2a20']]);
    ctx.beginPath(); ctx.moveTo(48, -84); ctx.lineTo(76, -84); ctx.lineTo(72, -70); ctx.lineTo(76, -56); ctx.lineTo(48, -56); ctx.closePath(); SG.draw.ink(ctx, '#f2c230', 1.6);
    ctx.fillStyle = '#7a2a1a'; ctx.font = '900 18px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('黃', 61, -69);
    ctx.restore();
  };
  return M;
}

// SG.MAP 永遠是同一個物件：各模組在載入時就抓住它（const M = SG.MAP），換地圖時清空再重算進同一個物件。
// 一次只有一張地圖有效（列傳模式只在單機用）；換圖後 onMapSwap 的處理會重新掛上（例如牆擋路）。
const M = buildMap();
SG.MAP = M;
const swaps = [];
SG.onMapSwap = (fn) => { swaps.push(fn); };
SG.useMap = (build = buildMap) => {
  for (const k of Object.keys(M)) delete M[k];
  build(M);
  swaps.forEach((fn) => fn(M));
};
SG.buildMap = buildMap;
